import MarketCollectionCard from './MarketCollectionCard'

export default MarketCollectionCard
